import React, { useState } from 'react';
import PropTypes from 'prop-types';
import resendVerificationEmail from '../../../../../../api/actions/resendVerificationEmail/resendVerificationEmail';
import { Message } from '@solarwindscloud/cloud-ui';
import { redirectTo } from '../../../../../../utils/utils';
import ROUTES from 'routes.json';
import styles from './ResendVerificationEmailError.module.scss';

const messageStates = {
  INITIAL: 'INITIAL',
  SENT: 'SENT',
};

export function ResendVerificationEmailError(props) {
  const { email, product, redirectTo, resendVerificationEmail } = props;

  const [messageState, setMessageState] = useState(messageStates.INITIAL);
  return render();

  function render() {
    if (messageState === messageStates.INITIAL) {
      return renderEmailIsNotVerified();
    } else {
      return renderEmailVerificationSent();
    }
  }

  async function handleResendVerificationEmail() {
    try {
      setMessageState(messageStates.SENT);
      await resendVerificationEmail(email, product);
    } catch (e) {
      redirectTo(ROUTES.ERROR);
    }
  }

  function renderEmailVerificationSent() {
    return (
      <Message positive>
        <div data-test-success-message="verificationEmailSent">Verification email has been sent.</div>
      </Message>
    );
  }

  function renderEmailIsNotVerified() {
    return (
      <Message error>
        <div data-test-error-message="resendVerificationEmail">
          Email is not verified.{' '}
          <span
            onClick={() => handleResendVerificationEmail()}
            data-test-link="resendVerificationEmail"
            className={styles.link}
          >
            Resend
          </span>{' '}
          verification email.
        </div>
      </Message>
    );
  }
}

ResendVerificationEmailError.propTypes = {
  redirectTo: PropTypes.func.isRequired,
  resendVerificationEmail: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  product: PropTypes.string,
};

export default props => (
  <ResendVerificationEmailError
    email={props.email}
    resendVerificationEmail={resendVerificationEmail}
    redirectTo={redirectTo}
    product={props.product}
  />
);
